export default __webpack_public_path__ + "static/media/church.57ed8247.jpg";